export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_tip-tracker-8/artifacts/84zv007g_LOGO%20MR%20JERRY.PNG";

export const WAITER_SHARE = 0.60;
export const KITCHEN_SHARE = 0.40;

export const SESSION_KEY = "mrjerry_user_session";
